"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const services_1 = require("modules/app/services");
const clubMigrationCta_1 = require("modules/app/services/datahubEvents/hotmartClub/clubMigrationCta");
const DashboardService_1 = __importDefault(require("modules/dashboard/DashboardService"));
const salesManager_1 = require("modules/salesManager");
const storageKey = 'newClubMigrationCtaClosed';
const useNewClubMigrationModal = (productId) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [hotmartClubData, setHotmartClubData] = (0, react_1.useState)({});
    const [isAccessPlus, setIsAccessPlus] = (0, react_1.useState)(true);
    const [hasShowModalCookie, setHasShowModalCookie] = (0, react_1.useState)(() => {
        const storageData = sessionStorage.getItem(storageKey);
        return Boolean(storageData);
    });
    (0, react_1.useEffect)(() => {
        const getIsAccessPlus = async () => {
            const isAccessPlusResponse = await salesManager_1.SalesService.getIsAccessPlus();
            setIsAccessPlus(isAccessPlusResponse);
            setIsLoading(false);
        };
        getIsAccessPlus();
    }, []);
    const handleDismiss = () => {
        setHasShowModalCookie(true);
        sessionStorage.setItem(storageKey, String(true));
        const schema = new clubMigrationCta_1.ClickDismissMigrationNewClub({
            componentName: services_1.ComponentNames.BUTTON_CLOSE_NEW_CLUB_MIGRATION_MODAL,
            productId: String(productId)
        });
        services_1.DatahubEventsService.sendEvent({
            schema
        });
    };
    const sendMigrationEvent = () => {
        const schema = new clubMigrationCta_1.ClickMigrationNewClub({
            componentName: services_1.ComponentNames.BUTTON_NEW_CLUB_MIGRATION_MODAL,
            productId: String(productId)
        });
        services_1.DatahubEventsService.sendEvent({
            schema
        });
        setHasShowModalCookie(true);
        sessionStorage.setItem(storageKey, String(true));
    };
    (0, react_1.useEffect)(() => {
        const fetchHotmartClubData = async () => {
            const data = await DashboardService_1.default.hasNewClub(productId);
            setHotmartClubData(data);
        };
        fetchHotmartClubData();
    }, [productId]);
    const isThisProductInNewClub = Boolean(hotmartClubData || !(0, isEmpty_1.default)(hotmartClubData));
    const shouldShowModal = !isThisProductInNewClub && !hasShowModalCookie;
    return {
        isLoading,
        shouldShowModal,
        handleDismiss,
        sendMigrationEvent,
        isAccessPlus
    };
};
exports.default = useNewClubMigrationModal;
